import { isValidAddress } from '$utils/isValidAddress';
import type { Address } from '$types/address';
export const match = (param: Address): boolean => isValidAddress(param);
